import { i18n } from '@lingui/core'
import { Text, View } from '@react-pdf/renderer'
import { getLabelFromTranslationData } from 'app/views/common/translationsCommon'
import {
    pdfSurveyQuestionSubFontSize, SurveyPdfNonApplicableCheckbox
} from '../PrintableReadyToFillSurvey'
import { PdfInputLine } from './SurveyTextInputQuestionPdf'

export default function SurveyRangeQuestionPdf ({ isGroup, ...props }) {
  if (isGroup) {
    return <GroupQuestionPdfView {...props} />
  } else {
    return <SingleQuestionPdfView {...props} />
  }
}

function GroupQuestionPdfView ({ groupQuestions, nonApplicable, ...props }) {
  return groupQuestions.map((question, index) => {
    return (
      <View key={index}>
        <Text
          style={{
            fontWeight: 'thin',
            paddingLeft: 10,
            fontSize: pdfSurveyQuestionSubFontSize,
            paddingTop: 10
          }}
        >
          {getLabelFromTranslationData({
            langVersion: props.version,
            data: question.titleValue
          })}
        </Text>
        <SingleQuestionPdfView {...question} />
        {nonApplicable && <SurveyPdfNonApplicableCheckbox />}
      </View>
    )
  })
}

function SingleQuestionPdfView ({ type, ...props }) {
  return <DottedLine />
}

const DottedLine = () => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        paddingTop: 4
      }}
    >
      <Text
        style={{
          fontSize: pdfSurveyQuestionSubFontSize,
          paddingLeft: 5,
          paddingRight: 5
        }}
      >
        {i18n._('from')}
      </Text>
      <PdfInputLine />
      <Text
        style={{
          fontSize: pdfSurveyQuestionSubFontSize,
          paddingLeft: 5,
          paddingRight: 5
        }}
      >
        {i18n._('to')}
      </Text>
      <PdfInputLine />
    </View>
  )
}
